import { TradeTrustToken__factory } from '@tradetrust-tt/token-registry-v4/contracts';
import { CodedError, OpenAttestationEthereumTokenRegistryStatusCode } from '@tradetrust-tt/tt-verify';
import { errors, constants } from 'ethers';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const isNonExistentToken = /* @__PURE__ */ __name((error) => {
  const message = error.message;
  if (!message) {
    return error.data && error.data.slice(0, 10) === "0x7e273289";
  }
  return message.includes("owner query for nonexistent token");
}, "isNonExistentToken");
const isMissingTokenRegistry = /* @__PURE__ */ __name((error) => {
  return !error.reason && error.method?.toLowerCase() === "ownerOf(uint256)".toLowerCase() && error.code === errors.CALL_EXCEPTION;
}, "isMissingTokenRegistry");
const decodeError = /* @__PURE__ */ __name((error) => {
  const reason = error.reason && Array.isArray(error.reason) ? error.reason[0] : error.reason ?? "";
  switch (true) {
    case isNonExistentToken(error):
      return `Document has not been issued under token registry`;
    case isMissingTokenRegistry(error):
      return `Token registry is not found`;
    case (reason.toLowerCase() === "ENS name not configured".toLowerCase() && error.code === errors.UNSUPPORTED_OPERATION):
      return "ENS name is not configured";
    case (reason.toLowerCase() === "invalid address".toLowerCase() && error.code === errors.INVALID_ARGUMENT):
      return `Invalid token registry address`;
    case error.code === errors.INVALID_ARGUMENT:
      return `Invalid contract arguments`;
    case error.code === errors.SERVER_ERROR:
    case error.code === errors.NETWORK_ERROR:
      throw new CodedError(
        "Unable to connect to the network, please try again later",
        OpenAttestationEthereumTokenRegistryStatusCode.SERVER_ERROR,
        OpenAttestationEthereumTokenRegistryStatusCode[OpenAttestationEthereumTokenRegistryStatusCode.SERVER_ERROR]
      );
    default:
      throw error;
  }
}, "decodeError");
const isTokenMintedOnRegistry = /* @__PURE__ */ __name(async ({
  tokenRegistryAddress,
  tokenId,
  provider
}) => {
  try {
    const tokenRegistryContract = TradeTrustToken__factory.connect(tokenRegistryAddress, provider);
    const minted = await tokenRegistryContract.ownerOf(tokenId).then((owner) => owner !== constants.AddressZero);
    return minted ? { minted, address: tokenRegistryAddress } : {
      minted,
      address: tokenRegistryAddress,
      reason: {
        code: OpenAttestationEthereumTokenRegistryStatusCode.DOCUMENT_NOT_MINTED,
        codeString: OpenAttestationEthereumTokenRegistryStatusCode[OpenAttestationEthereumTokenRegistryStatusCode.DOCUMENT_NOT_MINTED],
        message: `Document ${tokenId} has not been issued under contract ${tokenRegistryAddress}`
      }
    };
  } catch (error) {
    return {
      minted: false,
      address: tokenRegistryAddress,
      reason: {
        message: decodeError(error),
        // message: (error as Error).message,
        code: OpenAttestationEthereumTokenRegistryStatusCode.DOCUMENT_NOT_MINTED,
        codeString: OpenAttestationEthereumTokenRegistryStatusCode[OpenAttestationEthereumTokenRegistryStatusCode.DOCUMENT_NOT_MINTED]
      }
    };
  }
}, "isTokenMintedOnRegistry");

export { decodeError, isTokenMintedOnRegistry };
